export function areArrayEquals(
  feedArray1: any[] = [],
  feedArray2: any[] = [],
): boolean {
  // First check: if array2 has MORE items than array1, there's new content
  if (feedArray2.length > feedArray1.length) {
    return false;
  }

  // If array2 has LESS items, it's not new content, just removed items
  // We don't want to show toast for removed content
  if (feedArray2.length < feedArray1.length) {
    return true; // Consider it "equal" (don't show toast)
  }

  // Extract IDs from both arrays
  const ids1 = new Set<string>();
  const ids2 = new Set<string>();

  // Process array1
  for (const item of feedArray1) {
    if ('items' in item) {
      // This is a playlist with nested items, extract IDs from nested items
      const nestedIds = item.items
        .filter((nested: any) => 'id' in nested)
        .map((nested: any) => nested.id);
      nestedIds.forEach((id: string) => ids1.add(id));
    } else if ('id' in item) {
      ids1.add(item.id);
    }
  }

  // Process array2
  for (const item of feedArray2) {
    if ('items' in item) {
      const nestedIds = item.items
        .filter((nested: any) => 'id' in nested)
        .map((nested: any) => nested.id);
      nestedIds.forEach((id: string) => ids2.add(id));
    } else if ('id' in item) {
      ids2.add(item.id);
    }
  }

  // Check if there are NEW IDs in array2 that don't exist in array1
  for (const id of ids2) {
    if (!ids1.has(id)) {
      return false; // There are new items
    }
  }

  return true; // Same IDs, just different order
}
